import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Mensaje } from "../components/mensajes";
import axios from "axios";
import useTableScroll from "../components/useTableScroll.js";

const CatalogoEsctOrganizativa = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idcoordinacion.includes(target.value) ||
              x.nombrecoor.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombredir.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarUnidadEjecutora = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarunidadejecutora?id=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var uni = [];
          for (let i = 0; i < response.data.length; i++) {
            uni.push({
              nombredir: response.data[i].nombredir.trim(),
              nombrecoor: response.data[i].nombrecoor.trim(),
              idcoordinacion: response.data[i].idcoordinacion,
              iddireccion: response.data[i].iddireccion,
            });
          }
          setRecords(uni);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setItemSelect("");
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatUni();
  };

  const seleccionarAgentes = () => {
    blanquear();
    props.onHideAceptaCatUni(
      values.idcoordinacion,
      values.nombrecoor,
      values.nombredir
    );
    props.onHideCancelaCatUni();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    setValues({
      idcoordinacion: recordsAfterPagingAndSorting()[index].idcoordinacion,
      nombrecoor: recordsAfterPagingAndSorting()[index].nombrecoor,
      nombredir: recordsAfterPagingAndSorting()[index].nombredir,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="lg"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarUnidadEjecutora();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3 className="text-capitalize">Lista de Unidadades Ejecutoras</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12" style={{ marginBottom: "2px" }}>
          <div className="input-group col-md-4 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control"
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idcoordinacion}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombrecoor + "(" + item.nombredir + ")"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarAgentes}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default CatalogoEsctOrganizativa;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoEstructuraOrganizativa.js